import axios from "axios";
import { authAction } from "../actionTypes";
import { url } from "../../config/config";

export const loggedOut = () => ({ type: authAction.AUTH_LOGOUT })

export function checkSession() {
    return async dispatch => {
        try {
            const { data } = await axios.get(`${url}auth/me`)
            dispatch({ type: authAction.AUTH_CHECKED, payload: data.data })
        } catch {
            dispatch(loggedOut())
        }
    }
}

export function login(credentials) {
    return async dispatch => {
        const { data } = await axios.post(`${url}auth/login`, credentials)
        dispatch({ type: authAction.AUTH_LOGIN, payload: data.data })
        return data
    }
}

export function logout() {
    return async dispatch => {
        await axios.post(`${url}auth/logout`).catch(() => {})
        dispatch(loggedOut())
    }
}
